module.exports = __webpack_public_path__ + "img/retail.1179aa77.png";